import { createVanIconComponent } from "./van"

const ShoppingCartOutlined = createVanIconComponent("shopping-cart-o")
export default ShoppingCartOutlined
